import * as tslib_1 from "tslib";
import * as _ from 'lodash';
var translationOverrideMap = {
// 'APP.PRODUCT_PAGE_BUTTON_TEXT': 'ADD_TO_CART_BUTTON',
};
export function overrideTranslationsWithPublicData(translations, publicData) {
    return Object.keys(translationOverrideMap).reduce(function (acc, path) {
        var value = _.get(publicData, path);
        if (value) {
            acc[translationOverrideMap[path]] = value;
        }
        return acc;
    }, tslib_1.__assign({}, translations));
}
//# sourceMappingURL=productWidgetStore.utils.js.map